import React from 'react'
import { Dropdown } from 'react-bootstrap'
import styles from './SpaceActions.module.css'

const SpaceActions = ({ spaceId, spaceName, onEditSpace, onDeleteSpace }) => {
  const handleEdit = (e) => {
    e.stopPropagation()
    onEditSpace(spaceId, spaceName)
  }

  const handleDelete = (e) => {
    e.stopPropagation()
    onDeleteSpace(spaceId, spaceName)
  }

  return (
    <Dropdown className={styles.spaceActions} onClick={(e) => e.stopPropagation()}>
      <Dropdown.Toggle variant="link" className={styles.gearButton} id={`space-actions-${spaceId}`}>
        <img src="/assets/icons/setting-black.svg" alt="Space options" />
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.dropdownMenu}>
        <Dropdown.Item onClick={handleEdit} className={styles.dropdownItem}>
          <img src="/assets/icons/edit.svg" alt="" />
          <span>Rename</span>
        </Dropdown.Item>
        <Dropdown.Item onClick={handleDelete} className={styles.dropdownItem}>
          <img src="/assets/icons/trash.svg" alt="" />
          <span>Delete</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default SpaceActions
